import { NegotiationCounterValidationSchema } from "../schemas/negotiationCounter.schema";
import { NegotiationData } from "../types/negotiations.type";

export const negotiationCounterDefaultValues: (negotiation?: NegotiationData) => NegotiationCounterValidationSchema = (negotiation?: NegotiationData) => ({
  negotiation_products_attributes: negotiation?.negotiation_products?.map((negotiationProduct) => ({
    id: negotiationProduct.id,
    desired_action: negotiationProduct.status !== 'rejected' ? 'accept' : 'reject',
    value: '',
    counter_observation: '',
    reject_observation: '',
  })) || [],
});